// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-btn-container {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.button-content {
  cursor: pointer;
}

.upload-btn-container input[type=file] {
  cursor: pointer;
  font-size: 30px;
  filter: alpha(opacity=1);
  -moz-opacity: 0.01;
  opacity: 0.01;
  position: absolute;
  right: 0;
  top: 0;
}`, "",{"version":3,"sources":["webpack://./src/gamma/shared/components/fileuploadbutton/fileuploadbutton.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,gBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,eAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;AACJ","sourcesContent":[".upload-btn-container {\n    position: relative;\n    overflow: hidden;\n    display: inline-block;\n}\n\n.button-content {\n    cursor: pointer;\n}\n\n.upload-btn-container input[type=file] {\n    cursor: pointer;\n    font-size: 30px;\n    filter: alpha(opacity=1);\n    -moz-opacity: 0.01;\n    opacity: 0.01;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
